import { cfgCdnBase } from '@infinitro/config';
import Favorites from '../icons/icons-fomoio/favorites.svelte';
import Featurebuyin from '../icons/icons-fomoio/featurebuyin.svelte';
import GameShowsIcon from '../icons/icons-fomoio/game_shows.svelte';
import HotIcon from '../icons/icons-fomoio/hot.svelte';
import LiveCasinoIcon from '../icons/icons-fomoio/live_casino.svelte';
import LobbyIcon from '../icons/icons-fomoio/lobby.svelte';
import NewIcon from '../icons/icons-fomoio/new.svelte';
import OriginalsIcon from '../icons/icons-fomoio/originals.svelte';
import ProviderIcon from '../icons/icons-fomoio/providers.svelte';
import RecentlyPlayedIcon from '../icons/icons-fomoio/recently_played.svelte';
import SlotIcon from '../icons/icons-fomoio/slot.svelte';
import SportsIcon from '../icons/icons-fomoio/sports.svelte';
// others
import FacebookIcon from '../icons/facebook.svelte';
import GiftIcon from '../icons/gift.svelte';
import FomoBets from '../icons/icons-fomoio/fomo_bets.svelte';
import FomoJackpot from '../icons/icons-fomoio/fomo_jackpot.svelte';
import Points from '../icons/icons-fomoio/points.svelte';
import Promotion from '../icons/icons-fomoio/promotion.svelte';
import Raffles from '../icons/icons-fomoio/raffles.svelte';
import ReferEarn from '../icons/icons-fomoio/refer_earn.svelte';
import Tournaments from '../icons/icons-fomoio/tournaments.svelte';
import UpdownGame from '../icons/icons-fomoio/updown-game.svelte';
import VipClub from '../icons/icons-fomoio/vip-club.svelte';
import AmericanFootball from '../icons/icons-sport/american-football.svelte';
import AussieRules from '../icons/icons-sport/aussie-rules.svelte';
import Baseball from '../icons/icons-sport/baseball.svelte';
import Basketball from '../icons/icons-sport/basketball.svelte';
import Boxing from '../icons/icons-sport/boxing.svelte';
import CounterStrike from '../icons/icons-sport/counter-strike.svelte';
import Cricket from '../icons/icons-sport/cricket.svelte';
import Cycling from '../icons/icons-sport/cycling.svelte';
import Darts from '../icons/icons-sport/darts.svelte';
import Dota from '../icons/icons-sport/dota.svelte';
import ECricket from '../icons/icons-sport/e-cricket.svelte';
import Efighting from '../icons/icons-sport/e-fighting.svelte';
import EhorseRacing from '../icons/icons-sport/e-horse-racing.svelte';
import F1 from '../icons/icons-sport/f1.svelte';
import FavoritesSport from '../icons/icons-sport/favorites.svelte';
import Fifa from '../icons/icons-sport/fifa.svelte';
import Football from '../icons/icons-sport/football.svelte';
import Futsal from '../icons/icons-sport/futsal.svelte';
import Golf from '../icons/icons-sport/golf.svelte';
import Handball from '../icons/icons-sport/handball.svelte';
import IceHockey from '../icons/icons-sport/iceHockey.svelte';
import LeagueOfLegends from '../icons/icons-sport/league-of-legends.svelte';
import Live from '../icons/icons-sport/live.svelte';
import Mma from '../icons/icons-sport/mma.svelte';
import MyBets from '../icons/icons-sport/my-bets.svelte';
import NBA2K from '../icons/icons-sport/nba-2k.svelte';
import Nfl from '../icons/icons-sport/nfl.svelte';
import Racing from '../icons/icons-sport/racing.svelte';
import Rugby from '../icons/icons-sport/rugby.svelte';
import Schedule from '../icons/icons-sport/schedule.svelte';
import Snooker from '../icons/icons-sport/snooker.svelte';
import Specials from '../icons/icons-sport/specials.svelte';
import Squash from '../icons/icons-sport/squash.svelte';
import Starcraft from '../icons/icons-sport/starcraft.svelte';
import TableTennis from '../icons/icons-sport/table-tennis.svelte';
import Tennis from '../icons/icons-sport/tennis.svelte';
import Volleyball from '../icons/icons-sport/volleyball.svelte';
import Waterpolo from '../icons/icons-sport/waterpolo.svelte';
import InstagramIcon from '../icons/instagram.svelte';
import NotificationsIcon from '../icons/notifications02.svelte';
import Options from '../icons/options.svelte';
import ScrollUpIcon from '../icons/scroll-up.svg';
import Search from '../icons/search.svelte';
import TickIconAlternative from '../icons/tick-alternative.svg';
import TickIcon from '../icons/tick.svg';
import Usdt02 from '../icons/usdt02.svelte';
import Wallet02 from '../icons/wallet02.svelte';
import YoutubeIcon from '../icons/youtube.svelte';
const CDN_BASE = cfgCdnBase();
export const fomoIcons = {
    // category
    CardsIcon: LobbyIcon,
    LobbyIcon: LobbyIcon,
    CasinoIcon: LobbyIcon,
    OriginalsIcon: OriginalsIcon,
    OriginalsTabIcon: OriginalsIcon,
    PopularIcon: HotIcon,
    PopularTabIcon: HotIcon,
    NewGamesIcon: NewIcon,
    NewGamesTabIcon: NewIcon,
    PromotionIcon: Promotion,
    GiftIcon: GiftIcon,
    PointsIcon: Points,
    GameShowsIcon: GameShowsIcon,
    GameShowsTabIcon: GameShowsIcon,
    ProviderIcon: ProviderIcon,
    FeatureBuyInIcon: Featurebuyin,
    FeatureBuyInTabIcon: Featurebuyin,
    SlotsIcon: SlotIcon,
    SlotsTabIcon: SlotIcon,
    ReferralIcon: ReferEarn,
    AffiliateIcon: SlotIcon,
    VipIcon: VipClub,
    BlogIcon: `${CDN_BASE}/themes/fomoio/sidebar/blog.png`,
    LeaderboardIcon: `${CDN_BASE}/themes/fomoio/sidebar/fomoioraces.png`,
    LiveCasinoIcon: LiveCasinoIcon,
    LiveCasinoTabIcon: LiveCasinoIcon,
    AllGamesIcon: SlotIcon,
    AllGamesTabIcon: SlotIcon,
    RecentlyPlayedIcon: RecentlyPlayedIcon,
    RecentlyTabIcon: RecentlyPlayedIcon,
    FavoritesUserIcon: Favorites,
    SportsIcon: SportsIcon,
    FomoBetsIcon: FomoBets,
    JackpotIcon: FomoJackpot,
    TournamentsIcon: Tournaments,
    RafflesIcon: Raffles,
    ReferEarnIcon: ReferEarn,
    /* SPORTS */
    FootballIcon: Football,
    IceHockeyIcon: IceHockey,
    BaseballIcon: Baseball,
    TennisIcon: Tennis,
    GolfIcon: Golf,
    AmericanFootballIcon: AmericanFootball,
    RugbyIcon: Rugby,
    VolleyballIcon: Volleyball,
    FutsalIcon: Futsal,
    MmaIcon: Mma,
    F1Icon: F1,
    CyclingIcon: Cycling,
    DartsIcon: Darts,
    SnookerIcon: Snooker,
    BoxingIcon: Boxing,
    WaterpoloIcon: Waterpolo,
    CricketIcon: Cricket,
    SpecialsIcon: Specials,
    BetsIcon: MyBets,
    DotaIcon: Dota,
    eCricketIcon: ECricket,
    FavoritesIcon: FavoritesSport,
    FavoritesTabIcon: FavoritesSport,
    FifaIcon: Fifa,
    LoLIcon: LeagueOfLegends,
    LiveIcon: Live,
    NBA2KIcon: NBA2K,
    CounterStrikeIcon: CounterStrike,
    ScheduleIcon: Schedule,
    BasketballIcon: Basketball,
    RacingIcon: Racing,
    NFLIcon: Nfl,
    EfightingIcon: Efighting,
    EhorseRacingIcon: EhorseRacing,
    AussieRulesIcon: AussieRules,
    HandballIcon: Handball,
    SquashIcon: Squash,
    TableTennisIcon: TableTennis,
    StarCraftIcon: Starcraft,
    // others
    TickIcon: TickIcon,
    TickIconAlternative: TickIconAlternative,
    SearchIcon: Search,
    OptionsIcon: Options,
    Wallet02Icon: Wallet02,
    Usdt02Icon: Usdt02,
    WalletMobileIcon: Wallet02,
    UpdownGameIcon: UpdownGame,
    ScrollUpIcon: ScrollUpIcon,
    FacebookIcon: FacebookIcon,
    InstagramIcon: InstagramIcon,
    YoutubeIcon: YoutubeIcon,
    NotificationsIcon: NotificationsIcon
};
// https://gmcdn.org/themes/fomoio/sidebar/featurebuyin.svg
